const user = {
  namespaced: true,
  state: {
    accountVO: {},
    accountId: '',
    roleId: '',
    pageTitle: '',
    showNav: true,
    doubleCharge: '',
    vendingEasilyStatus: null,
    repurchaseEasilyStatus: null,
    riseOrderEasilyStatus: null,
    homeActivityPopup: { type: '', isShowPopup: false },
  },
  getters: {
    accountVO: state => state.accountVO,
    showNav: state => state.showNav,
    pageTitle: state => state.pageTitle,
  },
  mutations: {
    setAccountVO(state, accountVO = {}) {
      const { accountId, roleId } = accountVO;
      state.accountVO = accountVO;
      state.accountId = accountId;
      state.roleId = roleId;
    },
    setShowNav(state, show) {
      state.showNav = show;
    },
    setPageTitle(state, title) {
      state.pageTitle = title;
    },
    setDoubleCharge(state, data) {
      state.doubleCharge = data;
    },
    setVendingEasilyStatus(state, data) {
      state.vendingEasilyStatus = data;
    },
    setRepurchaseEasilyStatus(state, data) {
      state.repurchaseEasilyStatus = data;
    },
    setRiseOrderEasilyStatus(state, data) {
      state.riseOrderEasilyStatus = data;
    },
    setHomeActivityPopup(state, data) {
      state.homeActivityPopup = data;
    },
  },
  actions: {
    setAccountVO(content, accountVO) {
      content.commit('setAccountVO', accountVO);
    },
    setShowNav(content, show) {
      content.commit('setShowNav', show);
    },
    setPageTitle(context, title) {
      context.commit('setPageTitle', title);
    },
    set_DoubleCharge(context, data) {
      context.commit('setDoubleCharge', data);
    },
    set_VendingEasily_Status(context, data) {
      context.commit('setVendingEasilyStatus', data);
    },
    set_RepurchaseEasily_Status(context, data) {
      context.commit('setRepurchaseEasilyStatus', data);
    },
    set_RiseOrderEasily_Status(context, data) {
      context.commit('setRiseOrderEasilyStatus', data);
    },
    set_HomeActivityPopup(context, data) {
      context.commit('setHomeActivityPopup', data);
    },
  },
};

export default user;



// WEBPACK FOOTER //
// ./src/store/modules/user.js